import { Container, IInit } from '../../../common/container/Container'
import { Observable } from 'rxjs'
import { DownloadsRegister } from '../models/DownloadsRegister'
import { Query } from '../../../common/api/Query'
import { DownloadsRegisterDTO } from '../models/DownloadsRegisterDTO'
import { IDownloadsRegisterApi } from '../api/DownloadsRegister'
import { IStatusService } from '../../../common/status/StatusService'
import { STATUS_SERVICE_KEY } from '../../../container/app'
import { MonthlyDataQuery } from 'modules/statistics/models/MonthlyData'
import { File as F } from "../../../modules/files/models/File"


type Props = {
  apiKey: symbol
}

export interface IDownloadsRegisterService extends IInit {

  generateDRXLS(q: Query<MonthlyDataQuery>): Observable<F | undefined>

  add(e: DownloadsRegister): Observable<DownloadsRegister | undefined>

}

export class DownloadsRegisterService implements IDownloadsRegisterService {
  private readonly _apiKey: symbol
  private _container!: Container
  private _api!: IDownloadsRegisterApi
  private _statusService!: IStatusService

  constructor(p: Props) {
    this._apiKey = p.apiKey
  }

  init(c: Container) {
    this._container = c
    this._api = this._container.get<IDownloadsRegisterApi>(this._apiKey)
    this._statusService = this._container.get<IStatusService>(STATUS_SERVICE_KEY)
  }

  add(e: DownloadsRegisterDTO): Observable<DownloadsRegister | undefined> {
    return this._api.add(e)
  }


  generateDRXLS(q: Query<MonthlyDataQuery>): Observable<F | undefined> {
        return this._api.generateDRXLS(q)
    }


}
